import api from "../../api.js";
import web from "../../index.js";

export default class PageAdminNotifications
{
    deleteSub(button, username, subId, topic, channel)
    {
        if (confirm("delete " + topic + " for " + username + " via " + channel + "?"))
        {
            web.buttons.startSavingAnimButton(button);
            api.delete("activityfeed/" + subId, {}, () =>
            {
                web.buttons.stopSavingAnimButton(button);
                window.location.reload();
            }, (e) =>
            {
                console.log("e", e);
                web.buttons.stopSavingAnimButton(button, true, true);
            });
        }
    }
}
